<template>
  <v-container fluid>
    <!-- top toolbar START -->
    <v-row>
      <v-col cols="12">
        <v-toolbar 
          flat
        >
          <v-icon class="mr-3">mdi-domain</v-icon>
          <v-toolbar-title>Edit your Company</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn 
            :to="{path: '/settings/audit'}"
          >
            <v-icon left>mdi-ballot</v-icon>
            Audit Logs
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <!-- top toolbar END -->

    <v-row>
      <v-col cols="12">
        <!-- tabs START -->
        <v-tabs 
          v-model="active"
          slider-color="pink"
        >
          <v-tab
            v-for="(item, index) in tabs"
            :key="index"
            ripple
          >
            {{item}}
          </v-tab>
          <v-tabs-items v-model="active">
            <!-- information tab START -->
            <v-tab-item>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                      <span class="subheading">Make changes to objects belonging to your company.</span>
                    </v-col>
                </v-row>
                <template>
                  <form>
                    <v-row>
                      <v-col
                        cols="12"
                        md="8"
                      >
                        <v-select
                          v-model="delete_object_value"
                          :items="delete_object_items"
                          attach
                          chips
                          label="Objects to delete"
                          multiple
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                      
                        <v-btn
                            color="error" 
                            text
                            class="ml-3 mt-4"
                            @click.native="deleteObjects"
                            outlined
                          >
                            Delete objects
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-divider class="my-5"></v-divider>

                    <label class="">Do you wish to delete your company?</label><br>
                    <span class="help-block">Once the company is deleted, you won't be able to access any data that was linked to it.</span>

                    <!-- delete dialog START -->
                    <v-dialog 
                      v-model="deleteDialog" 
                      persistent 
                      max-width="400px"
                    >
                      <!-- delete company button START -->
                      <template v-slot:activator="{ on }">
                        <v-btn
                          slot="activator" 
                          color="error" 
                          text
                          class="mx-5" outlined
                        >
                          Delete my company
                        </v-btn>
                      </template>
                      <!-- delete company button END -->
                      <v-card>
                        <v-card-title class="headline">Delete the company</v-card-title>
                        <v-card-text>Are you sure you want to delete {{company.name}} ?</v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn 
                            color=""
                            text
                            @click.native="deleteDialog = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            text
                            @click.native="deleteCompany"
                          >
                            Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- delete dialog END -->
                  </form>
                </template>
              </v-container>
            </v-tab-item>
            <!-- information tab END -->
            <!-- environments tab START -->
            <v-tab-item>
            <v-layout row wrap>
              <function-environment-create-update></function-environment-create-update>
            </v-layout>
          </v-tab-item>
            <!-- environments tab END -->
          </v-tabs-items> 
        </v-tabs>
        <!-- tabs END -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SettingsService from './services/SettingsService'
  import { logout } from '../../../../utils/auth';
  import functionEnvCreateUpdate from './../Functions/FunctionEnvironmentCreateUpdate'

  export default {
    components:{
      'function-environment-create-update':functionEnvCreateUpdate
    },
    data: function() {
      return {
        company : {
          name : '',
        },
        tabs: ['information','environments'/*, 'security' , 'billing'*/],
        active: 0,
        deleteDialog: false,
        delete_object_items: ['project', 'dataset', 'api', 'function', 'query', 'dashboard', 'connector'],
        delete_object_value: []
      }
      
    },
    mounted: function(){
      var t = this
      SettingsService.getCompanyInfo()
      .then(function (response){
        t.company = response.data
      }).catch(function (error){
        t.$store.commit('push', {msg: error.response, color: 'error'});
      })
    },
    methods: {
      doCopy: function (txt) {
        window.prompt("Copy to clipboard: Ctrl+C, Enter", txt);        
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      deleteCompany(){
        var t = this
        SettingsService.deleteCompany()
        .then(function (response){
          logout()
        }).catch(function (error){
          t.$store.commit('push', {msg: error.response, color: 'error'});
        })
      },
      deleteObjects() {
        if (this.delete_object_value.length > 0) {
          var t = this
          SettingsService.companyReset(this.delete_object_value, this)
          this.delete_object_value = []
        }
      },
      changeCompanyInfo(){
        SettingsService.changeCompanyInfo(this.company, this)
      },
    }
  }
</script>
<style scoped>
</style>
